module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/favicon-o.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd5e77b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/logo-pad.vue
// module id = 573
// module chunks = 0